import {CreatedMaintenanceRecordRequest} from '@di-shared/api/di/__generated';

/**
 * 카테고리 번호 (엔진:1, 제동: 2, 공조: 3, 냉각수: 4)
 */
export enum SestCategory {
  ENGINE = 1,
  BRAKE = 2,
  AIR_CONDITIONER = 3,
  COOLANT = 4,
}

/**
 * 소모품 코드
 * 브레이크 패드 외에도 점화플러그도 빠진 아래 5가지 항목만 관리될 예정입니다. (cc: @박근 @김태준 )
 *
 * "엔진오일/필터, 에어클리너, 에어컨필터, 브레이크오일, 냉각수"
 * https://hmg.dooray.com/project/tasks/3861021658065369988#comment-3863300648350762310
 */
export enum SestCode {
  ENGINE_OIL_AND_FILTER = CreatedMaintenanceRecordRequest.sestCode._01, // 엔진오일 및 필터
  AIR_CLEANER = CreatedMaintenanceRecordRequest.sestCode._02, // 에어 클리너 필터
  AIR_CONDITIONER_FILTER = CreatedMaintenanceRecordRequest.sestCode._03, // 에어컨 필터
  SPARK_PLUG = CreatedMaintenanceRecordRequest.sestCode._04, // 점화 플러그
  BRAKE_OIL = CreatedMaintenanceRecordRequest.sestCode._09, // 브레이크오일
  BATTERY_12V = CreatedMaintenanceRecordRequest.sestCode._18, // 12V 배터리
  COOLANT = CreatedMaintenanceRecordRequest.sestCode._21, // 냉각수
}
